import { Button } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { useEffect, useState } from 'react'
import { AvForm } from 'availity-reactstrap-validation'
import Select from '../../../../CMSComponent/Forms/Fields/select'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { isSuccessResponse } from '../../../../helper'
import { fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'

const queryDropdown = {
  component_type: 'fields',
  component_name: 'select',
  name: 'query',
  is_layout: null,
  row_index: null,
  block_index: null,
  col: 12,
  section_rowspan: null,
  field_setting: {
    import: true,
    export: true,
    is_copy_allowed: null,
    depend_fields: null,
    disable_if: [],
    textarea: false,
  },
  cms_value: 'Query',
  permission: null,
  field_id: 'query_id',
  cms_key: 'field.query',
  cms_tooltip: null,
  component_call_data_connection: {
    component_type: 'data_connection',
    component_name: 'template_data',
    source_table: 'queries',
    fields: 'id,name',
    clause_data: [],
  },
  selected_value: null,
  disabled: false,
  hidden: false,
  search: false,
  hide_from_grid: false,
  background_color: false,
  component_call_validation: null,
  component_call_actions: null,
  component_call_fields: null,
  format: {
    size: 12,
    searchable: false,
    is_multi_select: true,
  },
  place_holder: null,
  cms_sub_heading: '',
}

const AddQueryDropdown = ({ gridRelatedData }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const dispatch = useDispatch()

  const [fieldData, setFieldData] = useState()
  const [selectedValue, setSelectedValue] = useState()

  useEffect(() => {
    const grid_id = gridRelatedData?.tableGrid?.main_grid?.id
    request('get-grid-form', 'POST', { grid_id }).then((res) => {
      const field = res?.data?.[0]?.component_call_fields?.find((item) => item?.field_id === 'query_id')
      if (field) {
        setFieldData(field)
      }
    })
  }, [])

  const onAddData = () => {
    let payload = {
      is_nested: true,
      parent_table: 'query_types',
      parent_table_row_id: currentRow?.[0]?.id,
      data: {
        queries: selectedValue,
      },
    }
    request('raise-ticket/link-querytype-query', 'POST', payload).then((res) => {
      if (isSuccessResponse(res, 'Query added successfully!')) {
        dispatch(fetchUpdateApiData())
        setSelectedValue()
      }
    })
  }
  if (!fieldData) return
  return (
    <AvForm style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Select data={fieldData} onChangeAction={(a, b, c, value, label) => setSelectedValue(value)} value={selectedValue} />
      </div>
      <div>
        <Button
          style={{ background: primary_color, marginTop: '2rem', marginLeft: '1rem' }}
          onClick={() => onAddData()}
          disabled={selectedValue?.length > 0 ? false : true}>
          Add
        </Button>
      </div>
    </AvForm>
  )
}

export default AddQueryDropdown
